import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';

const useSearchedTerm = (
	queryParameter = 'q',
	onSearchedTermNotSet?: () => void,
	onSearchedTermSet?: (searchTerm: string) => void,
	additionalQueryParameter?: string
) => {
	const navigate = useNavigate();
	const location = useLocation();

	const [searchedTerm, setSearchedTerm] = useState(
		new URLSearchParams(location.search).get(queryParameter) ?? ''
	);

	const [additionalSearchedTerm, setAdditionalSearchedTerm] = useState<string>(
		additionalQueryParameter
			? new URLSearchParams(location.search).get(additionalQueryParameter) ?? ''
			: ''
	);

	useEffect(() => {
		if (searchedTerm === '' && additionalSearchedTerm === '') {
			navigate(location.pathname);
		} else {
			let searchQuery = '?';
			const params: string[] = [];
			if (searchedTerm) {
				params.push(`${queryParameter}=${searchedTerm}`);
			}
			if (additionalSearchedTerm) {
				params.push(`${additionalQueryParameter}=${additionalSearchedTerm}`);
			}
			searchQuery += params.join('&');
			navigate(
				{
					pathname: location.pathname,
					search: searchQuery,
				},
				{ replace: false }
			);
		}

		if (searchedTerm === '') {
			if (onSearchedTermNotSet) {
				onSearchedTermNotSet();
			}
		} else {
			if (onSearchedTermSet) {
				onSearchedTermSet(searchedTerm);
			}
		}
	}, [
		searchedTerm,
		queryParameter,
		onSearchedTermNotSet,
		onSearchedTermSet,
		additionalSearchedTerm,
		additionalQueryParameter,
		location.pathname,
		navigate,
	]);

	return {
		searchedTerm,
		setSearchedTerm,
		additionalSearchedTerm,
		setAdditionalSearchedTerm,
	};
};

const ExportFunction = (
	...params: Parameters<typeof useSearchedTerm>
): ReturnType<typeof useSearchedTerm> => useSearchedTerm(...params);
export default ExportFunction;
